import { render, staticRenderFns } from "./Prognosis.vue?vue&type=template&id=3e06ef90&"
import script from "./Prognosis.vue?vue&type=script&lang=ts&"
export * from "./Prognosis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports